import React, { Component, Fragment } from "react";
import api from "../../../../services/api";
import SelectCampo from "../../Relatorio/Grafico/SelectCampo";
import Chart from "react-apexcharts";
import Select from "../../Relatorio/Grafico/Select";
import util from "../../../../utils/utils";
import calculo from "./calculo";

export default class Dashboard2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectCampo: 0,
            unidade: "Todas",
            series: [{
                data: []
            }],
            /**/
            options: {
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3,
                },
                xaxis: {
                    crosshairs: {
                        width: 1
                    },
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: function (value) {
                            return util.formataValor(value)
                        }
                    }
                },
                colors: ['#DCE6EC'],
                title: {
                    text: '',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                    }
                },
                subtitle: {
                    text: 'Pagos',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                    }
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    y: {
                        title: {
                            formatter: function (value) {
                                return 'Pago'
                            }
                        }
                    }
                }
            },
            

            /*
            options: {
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#77B6EA', '#545454', '#FEBC3B', "transparent"],
                dataLabels: {
                    enabled: false,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    background: {
                        enabled: true,
                        borderWidth: 1,
                    },
                },
                stroke: {
                    curve: 'smooth'
                },
                
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    labels: {show: false},
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                },
                yaxis: {
                    labels: {
                        show: false,
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }

                    }
                },
                fill: {
                    opacity: 0.3,
                },
            },
            */



            seriesSpark2: [{
                data: []
            }],
            optionsSpark2: {
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3,
                },
                xaxis: {
                    crosshairs: {
                        width: 1
                    },
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: function (value) {
                            return util.formataValor(value)
                        }
                    }
                },
                colors: ['#DCE6EC'],
                title: {
                    text: '',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                    }
                },
                subtitle: {
                    text: 'Gratuidade Regimental',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                    }
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    y: {
                        title: {
                            formatter: function (value) {
                                return 'Regimental'
                            }
                        }
                    }
                }
            },

            seriesSpark3: [{
                data: []
            }],
            optionsSpark3: {
                chart: {
                    type: 'area',
                    height: 160,
                    sparkline: {
                        enabled: true
                    },
                },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    opacity: 0.3
                },
                xaxis: {
                    crosshairs: {
                        width: 1
                    },
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: function (value) {
                            return util.formataValor(value)
                        }
                    }
                },
                colors: ['#DCE6EC'],
                title: {
                    text: '',
                    offsetX: 0,
                    style: {
                        fontSize: '24px',
                    }
                },
                subtitle: {
                    text: 'Gratuidade Não-Regimental',
                    offsetX: 0,
                    style: {
                        fontSize: '14px',
                    }
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    y: {
                        title: {
                            formatter: function (value) {
                                return 'Não-Regimental'
                            }
                        }
                    }
                },
            },

            series1: [{
                data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]
            }],
            options1: {
                chart: {
                    type: 'line',
                    width: 100,
                    height: 35,
                    sparkline: {
                        enabled: true
                    }
                },
                xaxis: {
                    crosshairs: {
                        width: 1
                    },
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    x: {
                        show: true
                    },
                    y: {
                        title: {
                            formatter: function (seriesName) {
                                return ''
                            }
                        }
                    },
                    marker: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        formatter: function (value) {
                            return util.formataValor(value)
                        }
                    }
                },
            },
            series4: [43, 32, 12, 9],
            options4: {
                chart: {
                    type: 'donut',
                    width: 40,
                    height: 40,
                    sparkline: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 1
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    y: {
                        formatter: function (value) {
                            return util.formataValor(value);
                        }
                    }
                },
                labels: ["Pagos", "Gratuidade Regimental", "Gratuidade Não-Regimental"],
            }
        };
    }

    async componentDidMount() {
        await this.loadMetas();
        this.calculaTipoPorMes();
    }

    loadMetas = async () => {
        let metas = await api.get("/metasformatadas");
        this.setState({ metas: metas.data.metas });
    }

    calculaTipoPorMes = (event) => {
        let { metas, selectCampo, modalidade, unidade } = this.state

        let resultado = calculo.calculaTipoPorMes({ metas, selectCampo, modalidade, unidade, event })

        this.setState({
            ...resultado,
            options: {
                title: {
                    text: util.formataValor(resultado.totais[0])
                }
            },
            optionsSpark2: {
                title: {
                    text: util.formataValor(resultado.totais[1])
                }
            },
            optionsSpark3: {
                title: {
                    text: util.formataValor(resultado.totais[2])
                }
            }
        });

    }

    render() {
        let { json, dados, nomeCampo, unidade } = this.state;

        return (

            <Fragment>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card ">
                            <div className="card-header ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">{unidade}</h5>
                                        <h6>{nomeCampo}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <Select selectUnidade={this.calculaTipoPorMes} />
                                    </div>
                                    <div className="col-md-3">
                                        <SelectCampo selectCampo={this.calculaTipoPorMes} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body ">

                                <div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div id="chart-spark1">
                                                <Chart options={this.state.options} series={[{ data: dados && dados[0] }]} type="area" height={160} />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div id="chart-spark2">
                                                <Chart options={this.state.optionsSpark2} series={[{ data: dados && dados[1] }]} type="area" height={160} />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div id="chart-spark3">
                                                <Chart options={this.state.optionsSpark3} series={[{ data: dados && dados[2] }]} type="area" height={160} />
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className="row">
                                        <table style={{ textAlign: 'start' }}>
                                            <thead style={{ textAlign: 'start' }}>
                                                <tr>
                                                    <th>Modalidade</th>
                                                    <th>Total</th>
                                                    <th>Subtotal</th>
                                                    <th>Pagos</th>
                                                    <th>Gratuidade Regimental</th>
                                                    <th>Gratuidade Não-Regimental</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {json && Object.keys(json).map((modalidade, i) => {
                                                    let data1 = util.formataValor(json[modalidade].total);
                                                    //let data2 = util.formataValor(json[modalidade].totalTipos)
                                                    let data3 = [{ data: json[modalidade].dados[0] }];
                                                    let data4 = [{ data: json[modalidade].dados[1] }];
                                                    let data5 = [{ data: json[modalidade].dados[2] }];
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td>{modalidade}</td>
                                                                <td>{data1}</td>
                                                                <td>
                                                                    <div id="chart-4">
                                                                        <Chart options={this.state.options4} series={json[modalidade].totalTipos} type="pie" height={40} width={40} />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div id="synced-charts">
                                                                    <div id="chart-1">
                                                                        <Chart options={this.state.options1} series={data3} type="area" height={40} width={130} />
                                                                    </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div id="chart-5">
                                                                        <Chart options={this.state.options1} series={data4} type="area" height={40} width={130} />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div id="chart-8">
                                                                        <Chart options={this.state.options1} series={data5} type="area" height={40} width={130} />
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                        </Fragment>

                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer ">
                                <hr />
                                <div className="stats">
                                    <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>

        )
    }
}
